@if (isStep2) {
  <app-edit-work-step2> </app-edit-work-step2>
} @else {
  <app-edit-work-step1></app-edit-work-step1>
}
